import React from 'react';

export default function template(context) {
    const calc = context.calc,
        model = calc.state.model;

    return (
        <React.Fragment>
            <div className="calculator-controllers">
                <div className="controller-block">
                    <div className="calc-block-title">
                        {calc.l10n('CALCULATOR_CREDIT_SUM')}
                    </div>

                    <div className="calculator-slider-wrapper">
                        <div className="calculator-slider-value">
                            {model.getCreditSum().toLocaleString()} {calc.l10n('CALCULATOR_UAH')}
                        </div>

                        <div className="calculator-slider">
                            <input type="range"
                                name="creditSum"
                                className="calculator-sum-slide"
                                onChange={calc.handleChange}
                                value={model.getCreditSum()}
                                min={model.getMinSumEdge()}
                                max={model.getMaxSumEdge()}
                                step={model.getSumStep()}
                            />
                        </div>
                    </div>
                </div>
                <div className="controller-block">
                    <div className="calc-block-title">
                        {calc.l10n('CALCULATOR_CREDIT_FORM')}
                    </div>
                    <div className="calculator-slider-wrapper">
                        <div className="calculator-slider-value">
                            {model.getCreditTerm()} {calc.l10n('CALCULATOR_MONTH')}
                        </div>

                        <div className="calculator-slider">
                            <input type="range"
                                name="creditTerm"
                                className="calculator-sum-slide"
                                onChange={calc.handleChange}
                                value={model.getCreditTerm()}
                                min={model.getMinTermEdge()}
                                max={model.getMaxTermEdge()}
                                step="1"
                            />
                        </div>
                    </div>
                </div>

                <div className="insurance-block">
                    <label className="container">
                        <input type="checkbox"
                            name="insured"
                            value={model.checkInsurance()}
                            onChange={calc.handleChangeInsurance} />
                        <span className="checkmark" />
                        {calc.l10n('CALCULATOR_INSURANCE')}
                    </label>
                    <p className="insurance-prescription">{calc.l10n('CALCULATOR_INSURANCE_TEXT')}</p>
                </div>
            </div>
        </React.Fragment>
    );
}
